/**
 * Cart Offcanvas View
 */
class CartOffcanvasView {

	constructor(presenter, sectionId) {

		this.parent = $("#shopify-section-" + sectionId);

		this.offcanvas = $("#mon-cart-offcanvas");
		this.cartItemsContainer = $("#mon-cart-offcanvas-items-container");
		this.cartEmptyContainer = $("#mon-cart-offcanvas-empty-container");
		this.cartItems = $("#mon-cart-offcanvas-items");
		this.cartItemTemplate = $("#mon-cart-offcanvas-item-template");
		this.totalPrice = $("#mon-cart-offcanvas-total-price");
		this.clearCart = $("#mon-cart-offcanvas-clear");

		this.presenter = presenter;
		
		/*
		 * Listeners
		 */

		this.clearCart.on("click", $.proxy(function(_event) {
			// request that all items are removed from the cart
			this.presenter.deleteItems();
		}, this));

	}

	/*
	 * Actions
	 */

	setCart(cart) {
		if (cart.items != null && cart.items.length > 0) {

			// remove anything it the items container, then iterate over the cart items
			this.cartItems.empty();
			for (const item of cart.items) {
				// add the entry to the cart
				const entry = this.createCartEntry(item);
				this.cartItems.append(entry);
			}
			
			// set the total price
			const totalPrice = this.getFormattedNumber(cart.total_price / 100);
			this.totalPrice.text(totalPrice);

			// show the cart items container
			this.cartItemsContainer.removeClass("d-none").addClass("d-flex");
			this.cartEmptyContainer.removeClass("d-block").addClass("d-none");

		}
		else {
			
			// show the cart empty container
			this.cartItemsContainer.removeClass("d-flex").addClass("d-none");
			this.cartEmptyContainer.removeClass("d-none").addClass("d-block");

		}
	}

	updateCart(cart, delta) {
		
		// get the variant id and get the corresponding entry in items container
		const variantId = delta.id;
		const entry = this.cartItemsContainer.find(".mon-cart-offcanvas-item[data-variant-id='" + variantId + "']");
		if (entry == null) { console.warn("Could not locate entry in cart items container for variant id: " + variantId); }
		
		// get the cart item for this variant id (if there is one)
		var item = null;
		for (const cartItem of cart.items) {
			if (cartItem.variant_id == variantId) { item = cartItem; }
		}
		
		// check if we have a cart item int the cart retrieved from shopify for this variant
		if (item != null) {
			// we do have a cart item, so create a new cart entry, then replace the existing entry in the cart view
			const newEntry = this.createCartEntry(item);
			entry.replaceWith(newEntry);
			// set the total price
			const totalPrice = this.getFormattedNumber(cart.total_price / 100);
			this.totalPrice.text(totalPrice);
		}
		else if (cart.items.length > 0) {
			// there is no cart item for the variant but there are other items, so remove the entry from the cart view
			entry.remove();
			// set the total price
			const totalPrice = this.getFormattedNumber(cart.total_price / 100);
			this.totalPrice.text(totalPrice);
		}
		else {
			// there are no items in the cart retrieved from shopify, so refresh the cart view
			this.setCart(cart);
		}

	}

	createCartEntry(item) {
		
		// clone the cart item template
		const entry = this.cartItemTemplate.clone();
		entry.removeAttr("id");
		entry.removeClass("d-none");

		// set the info into the entry
		entry.attr("data-variant-id", item.variant_id);
		entry.find(".mon-cart-offcanvas-item-img").first().attr("src", item.image);
		entry.find(".mon-cart-offcanvas-item-vendor").first().text(item.vendor);
		entry.find(".mon-cart-offcanvas-item-title").first().text(item.product_title);
		if (item.variant_title != null && item.variant_title.length > 0) { entry.find(".mon-cart-offcanvas-item-variant-title").first().text(item.variant_title); }
		entry.find(".mon-cart-offcanvas-item-quantity").first().text(item.quantity);
		entry.find(".mon-cart-offcanvas-item-quantity").first().attr("data-quantity", item.quantity);
		entry.find(".mon-cart-offcanvas-item-line-price").first().text(this.getFormattedNumber(item.final_line_price / 100));

		// setup the delete listener
		entry.find(".mon-cart-offcanvas-item-remove").on("click", $.proxy(function(_event) {
			// update the quantity of this variant to zero
			this.presenter.updateItemQuantity(item.variant_id, 0)
		}, this));

		return entry

	}

	showCart() {
		// show the cart
		const bootstrapCart = new bootstrap.Offcanvas(this.offcanvas);
		bootstrapCart.show();
	}

	/*
	 * Getters and Setters
	 */

	getFormattedNumber(number) {
		const result = number.toLocaleString(undefined, {
			minimumFractionDigits: 0,
			maximumFractionDigits: 0
		});
		return result;
	}

}